import { defineMessages } from "react-intl";

const messages = defineMessages({
  showMore: {
    defaultMessage: "Show more",
    id: "checkboxList.more",
    description:
      "The text on the button that expands a truncated list of checkboxes.",
  },
  showLess: {
    defaultMessage: "Show less",
    id: "checkboxList.less",
    description:
      "The text on the button that collapses an expanded list of checkboxes.",
  },
  noneAvailable: {
    defaultMessage: "No options available",
    id: "checkboxList.none",
    description:
      "The text that displays when there are no checkboxes available to be displayed.",
  },
});

export default messages;
